{
  "views": {
    "front": "ด้านหน้า",
    "back": "ด้านหลัง",
    "corner_tl": "มุมซ้ายบน",
    "corner_tr": "มุมขวาบน",
    "corner_bl": "มุมซ้ายล่าง",
    "corner_br": "มุมขวาล่าง",
    "label": "ฉลากเกรด",
    "zoom": "ภาพซูม",
    "surface": "ผิวการ์ดเอียงรับแสง",
    "edge": "ขอบการ์ด"
  },
  "views_hint": {
    "front": "วางการ์ดทั้งใบในกรอบ ด้านหน้าขึ้น",
    "back": "พลิกการ์ด ให้ด้านหลังทั้งใบอยู่ในกรอบ",
    "corner_tl": "ถ่ายใกล้ๆ มุมซ้ายบน",
    "corner_tr": "ถ่ายใกล้ๆ มุมขวาบน",
    "corner_bl": "ถ่ายใกล้ๆ มุมซ้ายล่าง",
    "corner_br": "ถ่ายใกล้ๆ มุมขวาล่าง",
    "label": "ฉลากเกรดที่เห็นเลข cert",
    "zoom": "รอยหรือจุดที่ลูกค้าควรเห็น",
    "surface": "เอียงการ์ดให้แสงเห็นรอยขีดข่วน",
    "edge": "ขอบการ์ดหรือกล่อง"
  },
  "camera": {
    "step": "รูปที่ {{n}} จาก {{count}}: {{name}}",
    "title": "กล้อง",
    "close": "ปิดกล้อง",
    "denied": "กล้องยังไม่ได้รับอนุญาต เปิดสิทธิ์กล้องให้เว็บนี้ในการตั้งค่าเบราว์เซอร์ หรือใช้ “เลือกรูป”",
    "unavailable": "ไม่พบกล้องในเครื่องนี้ ใช้ “เลือกรูป” แทน",
    "retake": "ถ่ายใหม่",
    "shoot": "ถ่ายรูป",
    "skip": "ข้าม"
  },
  "gallery": {
    "edit_alt": "แก้คำอธิบาย",
    "alt_title": "คำอธิบายรูป",
    "alt_hint": "ใช้อ่านให้ลูกค้าที่มองไม่เห็นและให้เว็บค้นหา",
    "alt_en": "อังกฤษ",
    "alt_th": "ไทย",
    "alt_save": "บันทึก",
    "picture_n": "รูปที่ {{n}} จาก {{count}}",
    "sortable": "รูปที่ย้ายได้",
    "main": "รูปหลัก",
    "move_earlier": "ย้าย {{name}} ไปก่อน",
    "move_later": "ย้าย {{name}} ไปหลัง",
    "make_main": "ตั้ง {{name}} เป็นรูปหลัก",
    "remove": "เอา {{name}} ออก",
    "moved": "รูปที่ {{from}} ตอนนี้อยู่ลำดับ {{to}} จาก {{count}}",
    "removed": "เอารูปที่ {{n}} ออกแล้ว",
    "keys_hint": "ปุ่มลูกศรย้ายรูป Home ตั้งเป็นรูปหลัก Delete เอาออก",
    "removed_toast": "เอารูปออกแล้ว",
    "alt_failed": "บันทึกคำอธิบายไม่ได้ — ลองอีกครั้ง"
  },
  "uploader": {
    "progress": "กำลังอัปโหลด {{name}}",
    "heic_note": "รูปจาก iPhone (HEIC) จะถูกแปลงหลังอัปโหลด",
    "retry": "ลองอีกครั้ง",
    "cancel": "หยุดอัปโหลด {{name}}",
    "dismiss": "เอา {{name}} ออกจากรายการ",
    "too_many": "ใส่ได้ {{max}} รูปเท่านั้น — {{left}} รูปไม่ได้เพิ่ม",
    "camera_step": "ถ่ายรูป: {{name}} ({{n}}/{{count}})",
    "camera": "ถ่ายรูป",
    "camera_one": "ถ่ายรูป",
    "count": "{{count}} จาก {{max}} รูป",
    "remove_file": "เอาออก",
    "no_photos": "ยังไม่มีรูป — ใส่อย่างน้อยด้านหน้าก่อนเปิดขาย",
    "in_progress": "ไฟล์ที่กำลังส่ง",
    "drop_zone": "เพิ่มรูป: ลากไฟล์มาวาง วาง (paste) หรือใช้ปุ่ม",
    "secure_note": "เก็บแบบเข้ารหัส — เปิดได้เฉพาะพนักงานที่มีสิทธิ์",
    "drop_hint_many": "ลากรูปมาวางที่นี่ วาง (paste) หรือใช้ปุ่ม — อัปโหลดเองอัตโนมัติ",
    "drop_hint_one": "ลากไฟล์มาวางที่นี่ วาง (paste) หรือใช้ปุ่ม",
    "choose_many": "เลือกรูป",
    "choose_one": "เลือกไฟล์",
    "pick_existing": "ใช้รูปที่อัปโหลดไว้แล้ว",
    "skip_step": "ข้ามรูปนี้",
    "full": "ใช้ครบ {{max}} ช่องแล้ว เอารูปออกก่อนถ้าจะเพิ่ม",
    "busy_other": "ยังอัปโหลดอยู่ {{count}} ไฟล์…"
  },
  "status": {
    "preparing": "กำลังเตรียม…",
    "waiting": "รอคิว…",
    "uploading": "กำลังอัปโหลด…",
    "processing": "ใกล้เสร็จแล้ว…",
    "offline": "ไม่มีอินเทอร์เน็ต — จะส่งต่อเองเมื่อกลับมา",
    "ready": "เสร็จแล้ว",
    "failed": "อัปโหลดไม่สำเร็จ",
    "rejected": "ใช้ไม่ได้",
    "cancelled": "หยุดแล้ว"
  },
  "problem": {
    "not_image": "ไฟล์นี้ไม่ใช่รูปภาพ",
    "type": "ใช้ไฟล์ชนิดนี้ที่นี่ไม่ได้ ใช้ JPEG, PNG, WebP หรือรูปจาก iPhone",
    "too_large": "ไฟล์ใหญ่เกินไป",
    "empty": "ไฟล์ว่างเปล่า",
    "size_mismatch": "ไฟล์เปลี่ยนระหว่างอัปโหลด — ลองอีกครั้ง",
    "corrupt_file": "ไฟล์เสีย เปิดไม่ได้",
    "processing_failed": "เตรียมรูปไม่สำเร็จ — อัปโหลดใหม่",
    "processing_timeout": "ใช้เวลานานกว่าปกติ อาจขึ้นมาทีหลัง — หรือลองอีกครั้ง",
    "network_error": "การเชื่อมต่อหลุด ลองอีกครั้ง",
    "other": "ใช้ไฟล์นี้ไม่ได้"
  },
  "restricted": {
    "stored": "เก็บอย่างปลอดภัยแล้ว",
    "alt": "เอกสารที่เก็บไว้",
    "error": "เปิดไฟล์ไม่ได้ ลองอีกครั้งหรือถามผู้จัดการ",
    "hide": "ซ่อน",
    "loading": "กำลังเปิด…",
    "show": "แสดง",
    "note": "การเปิดดูจะถูกบันทึก รูปไม่ถูกเก็บในเครื่องนี้"
  },
  "picker": {
    "title": "รูปที่อัปโหลดไว้",
    "close": "ปิด",
    "search": "ค้นด้วยชื่อหรือคำอธิบาย",
    "loading": "กำลังโหลด…",
    "error": "โหลดรูปไม่ได้",
    "empty": "ไม่พบรูป",
    "results": "รูป",
    "picture": "รูป",
    "more": "ดูเพิ่ม",
    "cancel": "ยกเลิก",
    "add_other": "เพิ่ม {{count}} รูป"
  }
}
